import {HomeRes} from '@/root/models/home';

import {DicaronCommonErrorCode, DicaronIssueAndHomeErrorCode} from '@/shared/constants/dicaronServerErrorCode';
import {usePopupSetter} from '@/shared/hooks/usePopupSetter';

export type PopupType = 'CARD_DELETE' | 'CARD_DELETE_FAIL' | 'SERVER_ERROR' | 'PAPAS_ERROR' | 'HOME_EVENT';

type CardDeleteFailPopupProps = {};

export type CardDeletePopupProps = {
  onSubmit: () => void;
  selectedCardCount: number;
};

export type ServerErrorPopupProps = {
  errorCode: DicaronCommonErrorCode;
  onSubmit: () => void;
};

export type PapasErrorPopupProps = {
  errorCode: DicaronIssueAndHomeErrorCode;
  onSubmit?: () => void;
};

export type HomeEventPopupProps = NonNullable<HomeRes['popupBanner']>;

export type PopupPropsMap = {
  CARD_DELETE: CardDeletePopupProps;
  CARD_DELETE_FAIL: CardDeleteFailPopupProps;
  SERVER_ERROR: ServerErrorPopupProps;
  PAPAS_ERROR: PapasErrorPopupProps;
  HOME_EVENT: HomeEventPopupProps;
};

const usePopup = () => {
  const setPopup = usePopupSetter<PopupType>();

  const openPopup = <T extends PopupType>(type: T, props?: PopupPropsMap[T]) => {
    setPopup({isOpen: true, type, props});
  };

  const closePopup = () => {
    setPopup({isOpen: false});
  };

  return {openPopup, closePopup};
};

export default usePopup;
